export const environment = {
  //Environment for Azure DEV deployment
  production: true,
  RestServer: 'https://api-space-ar-dev.azurewebsites.net/api/',
  AceParkUrl: 'dev.acepark.net',
  SpaceRestServer: 'https://spacestage.aceparking.com/services/v2/',
  SpaceArPublic:
    'https://ng-space-ar-public-dev-aqbhgfgphqesf9d3.canadacentral-01.azurewebsites.net',
  ClassTopNav: 'topnavdev',
  EnvironmentDescription: 'AWS APN DEV Server',
  UrlDomain: 'dev.acepark.net',
  spaceEngineRestServer:
    'https://dev-api-space-ar-engine-bvadaehuefagfudd.westus2-01.azurewebsites.net/api/',
};
